import type { Translations } from "../keys.js";

export const fr = {
  eyebrow: "Relevé d'activité IBKR",
  title: "Rapport ratio gain/perte",
  uploadMark: "Flex XML",
  uploadTitle: "Déposez ou choisissez un XML IBKR",
  uploadBody: "Nom, compte et adresse sont masqués localement.",
  nfaDisclaimer: "Réservé à l'apprentissage et à la revue de trades. Pas un conseil financier.",
  chooseFile: "Choisir fichier",
  account: "Compte",
  name: "Nom",
  neutralName: "momo",
  period: "Période",
  baseCurrency: "Devise de base",
  closed: "clôturées",
  executions: "exécutions",
  netRealized: "Réalisé net",
  winRate: "Taux de réussite",
  payoffRatio: "Ratio gain/perte",
  expectancy: "Espérance",
  executionRecords: "Exécutions",
  canceledOrders: "Ordres annulés",
  medianHoldingDays: "Durée médiane",
  commissionDrag: "Commissions",
  closedTradeSum: "Total des clôtures",
  grossProfitLoss: "Gain brut / perte brute",
  averageWinLoss: "Gain moyen / perte moyenne",
  perClosedTrade: "Par trade clôturé",
  flexTradeRecords: "Enregistrements Trade Flex XML",
  flexCanceledRecords: "Enregistrements Order annulés dans Flex XML",
  noCanceledRecords: "Aucun ordre annulé dans ce XML",
  holdingReview: "Holding",
  holdingReviewTitle: "Analyse durée de détention et ratio",
  holdingReviewHint: "Associe ouvertures et clôtures, puis compare PF, ratio et réussite par durée de détention.",
  holdingPeriod: "Durée de détention",
  holdingIntraday: "Intraday",
  holdingSwing: "1-7 jours",
  holdingPosition: "8-30 jours",
  holdingLongTerm: "30+ jours",
  directionReview: "Direction",
  directionReviewTitle: "Analyse long / short",
  directionReviewHint: "Sépare les trades clôturés par exposition de stratégie pour voir le côté le plus performant.",
  longPosition: "Long",
  shortPosition: "Short",
  neutralPosition: "Neutre",
  equityCurve: "Courbe de capital",
  dailyRealized: "P/L réalisé quotidien",
  payoff: "Ratio gain/perte",
  winLossDistribution: "Distribution gains/pertes",
  periodPerformance: "Performance par période",
  periodHint: "Barres vertes : gain ; rouges : perte. PF et ratio sont dans le tableau ci-dessous.",
  weekly: "Hebdo",
  monthly: "Mensuel",
  periodColumn: "Période",
  monthColumn: "Mois",
  realized: "Réalisé",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "Ratio",
  trades: "Trades",
  assetBreakdown: "Actifs",
  assetBreakdownTitle: "Stats actions / options",
  asset: "Actif",
  medianPnl: "P/L médian",
  average: "Moyenne",
  optionReview: "Options",
  optionReviewTitle: "Options par sous-jacent",
  underlying: "Sous-jacent",
  date: "Date",
  dateCount: "Dates",
  daysShort: "j",
  hoursShort: "h",
  minutesShort: "min",
  weakestSession: "Session la plus faible",
  intradaySessionNoData: "Aucune clôture en séance régulière",
  intradaySessionTitle: "Taux de réussite ouverture / midi / clôture",
  intradaySessionHint: "Regroupe les clôtures par session pour comparer réalisé, P/L médian, moyenne, PF, ratio et réussite.",
  weekdayReviewTitle: "Performance par jour de semaine",
  weekdayReviewHint: "Compare les clôtures de séance régulière et les expirations automatiques par jour afin de montrer le meilleur et le pire ratio gain/perte.",
  weekday: "Jour",
  weekdaySunday: "Dimanche",
  weekdayMonday: "Lundi",
  weekdayTuesday: "Mardi",
  weekdayWednesday: "Mercredi",
  weekdayThursday: "Jeudi",
  weekdayFriday: "Vendredi",
  weekdaySaturday: "Samedi",
  bestDay: "Meilleur",
  worstDay: "Pire",
  session: "Session",
  sessionMorning: "Ouverture",
  sessionMidday: "Midi",
  sessionLate: "Clôture",
  autoExpiry: "Expiration auto",
  optionLifecycle: "Expiration / règlement",
  optionLifecycleRegularClose: "Clôture normale",
  optionLifecycleEp: "Expirée",
  optionLifecycleEx: "Exercice",
  optionLifecycleA: "Assignation",
  optionLifecycleCD: "Règlement en espèces",
  optionLifecycleAEx: "Exercice automatique",
  optionLifecycleMEx: "Exercice manuel",
  optionLifecycleGEA: "Expiration / assignation compensée",
  discipline: "Discipline",
  disciplineRisk: "Risque de discipline",
  largeLossAlert: "Alerte grosse perte",
  largeLossDiscipline: "Pause d'abord. Protège la discipline.",
  largeLossRule: "La perte totale de cette journée dépasse le seuil de risque actuel. N'augmente pas la taille pour la récupérer avant de revoir le stop prévu, la perte journalière maximale et la règle de pause.",
  worstLossDay: "Pire perte journalière",
  symbols: "Symboles",
  symbolPerformance: "Classement des symboles",
  page: "Page",
  previousPage: "Page précédente",
  nextPage: "Page suivante",
  offlineCoach: "Coach hors ligne",
  offlineAdvice: "Conseils hors ligne",
  bestLoserWins: "Le meilleur perdant gagne",
  theme: "Thème",
  language: "Langue",
  dark: "Sombre",
  light: "Clair",
  stock: "Actions",
  option: "Options",
  other: "Autres",
  cash: "Espèces",
  future: "Contrat futur",
  unknown: "Inconnu",
  lossBucketSmall: "Petite perte",
  lossBucketMedium: "Perte moyenne",
  lossBucketLarge: "Grande perte",
  winBucketSmall: "Petit gain",
  winBucketMedium: "Gain moyen",
  winBucketLarge: "Grand gain",
  chartEmpty: "Aucun trade clôturé à afficher",
  dailyChartLegend: "barres : quotidien, ligne : cumulé",
  periodChartLegend: "points PF, réf. 1.00, plafond",
  importFailed: "Échec import",
  profitStatus: "Gain",
  lossStatus: "Perte",
  flatStatus: "Stable",
  costStatus: "Coût",
  toggleDetails: "Afficher les détails",
  "error.invalid_flex_xml": "Téléversez un fichier IBKR Flex XML.",
  "advice.profit_factor_below_one.title": "Le PF est inférieur à 1",
  "advice.profit_factor_below_one.body": "Le PF actuel est {profitFactor}. Les gains totaux ne couvrent pas encore les pertes totales. Réduis d'abord les grosses pertes, les pertes à expiration et les renforcements non maîtrisés avant d'augmenter le nombre de trades.",
  "advice.profit_factor_thin_edge.title": "Le PF a une marge fragile",
  "advice.profit_factor_thin_edge.body": "Le PF actuel est {profitFactor}. C'est tradable, mais une ou deux pertes non maîtrisées peuvent effacer toute la période. Définis d'abord la perte journalière maximale, l'heure de sortie limite et les règles de pause.",
  "advice.profit_factor_healthy.title": "La structure du PF paraît plus saine",
  "advice.profit_factor_healthy.body": "Le PF actuel est {profitFactor}. N'augmente pas la fréquence à l'aveugle. Identifie les symboles, sessions et setups répétables, puis conserve seulement les trades de meilleure qualité.",
  "advice.winrate_and_payoff_weak.title": "Taux de réussite et payoff ne doivent pas être faibles ensemble",
  "advice.winrate_and_payoff_weak.body": "Le taux de réussite est {winRate} et le payoff est {payoffRatio}. Ni le taux de réussite ni le gain moyen ne compensent assez. Vérifie l'espace cible et la distance du stop avant l'entrée.",
  "advice.high_winrate_weak_payoff.title": "Le taux de réussite masque un payoff faible",
  "advice.high_winrate_weak_payoff.body": "Le taux de réussite est {winRate}, mais le payoff est {payoffRatio}. Un mauvais trade peut consommer plusieurs bons trades. C'est souvent un problème de sortie et de définition du risque, pas seulement de direction.",
  "advice.overtrade_loss_days.title": "Les jours perdants montrent une accélération",
  "advice.overtrade_loss_days.body": "{days} jours ont combiné beaucoup de trades et un PnL négatif. Revois séparément les trades après la première perte : faisaient-ils encore partie du plan ou cherchaient-ils à récupérer ?",
  "advice.auto_expiry_losses.title": "Les pertes par expiration automatique ne sont pas du bruit",
  "advice.auto_expiry_losses.body": "{count} pertes par expiration automatique ont été incluses. L'expiration à zéro doit être traitée comme un risque gérable, pas comme un accident de fin de journée. Note l'heure de sortie limite acceptable.",
  "advice.good_loser_base.title": "Un bon perdant protège le trade suivant",
  "advice.good_loser_base.body": "Le gain moyen est {avgWin} et la perte moyenne est {avgLoss}. Les pertes dans le plan sont des coûts; les pertes hors plan signifient que le risque doit être resserré.",
  "advice.detach_outcome_from_ego.title": "Sépare le PnL de l'ego",
  "advice.detach_outcome_from_ego.body": "Pendant la revue, demande d'abord : cette perte est-elle arrivée selon le plan ? Si oui, c'est un coût. Sinon, c'est un problème de discipline.",
  "advice.large_tail_losses.title": "Réduis d'abord les plus grosses pertes",
  "advice.large_tail_losses.body": "{count} pertes ont dépassé {threshold}. Le moyen le plus rapide d'améliorer le PF n'est souvent pas d'augmenter le taux de réussite, mais de couper les pertes extrêmes qui détruisent une semaine entière.",
  "advice.asset_group_relative_edge.title": "{stronger} montrent actuellement un avantage relatif",
  "advice.asset_group_relative_edge.body": "Le PF des options est {optionProfitFactor}; le PF des actions est {stockProfitFactor}. Mets capital et attention là où le PF est plus stable, puis vérifie si le segment faible venait de tests ponctuels ou de trading émotionnel.",
  "advice.option_sample_dominant.title": "L'échantillon actuel est surtout composé d'options",
  "advice.option_sample_dominant.body": "Le PF des options est {optionProfitFactor} avec un taux de réussite de {optionWinRate}. Revois séparément expiration, exercice/assignation, décisions de dernière séance et variations d'IV.",
  "advice.stock_sample_dominant.title": "L'échantillon actuel est surtout composé d'actions",
  "advice.stock_sample_dominant.body": "Le PF des actions est {stockProfitFactor} avec un taux de réussite de {stockWinRate}. Vérifie durée de détention, cohérence des stops et entrées poursuivies avant de mélanger actions et options.",
  "advice.weak_option_underlying_days.title": "Revoir séparément les jours faibles sur options",
  "advice.weak_option_underlying_days.body": "{rows}. Ces combinaisons sont plus proches du contexte réel de décision que le tableau résumé. Vérifie d'abord direction, moment d'entrée et proximité de l'expiration.",
  "advice.clean_sample.title": "Garde un échantillon propre",
  "advice.clean_sample.body": "Aucune classe d'actifs ne tire clairement le résultat vers le bas. Continue à accumuler des trades clôturés propres, puis analyse cyclicité, concentration par symbole et stabilité des setups.",
} satisfies Translations;
